/* UD · Accueil style revendeur — carrousel principal et rangées défilantes (sans dépendance). */
(function () {
  'use strict';
  try {
    var ua = navigator.userAgent || '';
    if (/Mac OS X|iPhone|iPad|iPod/.test(ua)) document.documentElement.classList.add('udia-apple-os');
  } catch (e) {}

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Carrousel principal ---------- */
  function Hero(root) {
    this.root = root;
    this.track = root.querySelector('.udia-hero__track');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('.udia-hero__slide'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('.udia-hero__dot'));
    this.pauseBtn = root.querySelector('.udia-hero__pause');
    this.live = root.querySelector('.udia-hero__live');
    this.i = 0;
    this.delay = (parseInt(root.dataset.speed, 10) || 6) * 1000;
    this.auto = root.dataset.autoplay === 'true' && !reduce && this.slides.length > 1;
    this.paused = !this.auto;
    this.hover = false;
    if (this.slides.length < 2) return;
    var self = this;
    this.dots.forEach(function (d, k) { d.addEventListener('click', function () { self.go(k, true); }); });
    var p = root.querySelector('.udia-hero__arrow--prev'), n = root.querySelector('.udia-hero__arrow--next');
    if (p) p.addEventListener('click', function () { self.go(self.i - 1, true); });
    if (n) n.addEventListener('click', function () { self.go(self.i + 1, true); });
    if (this.pauseBtn) {
      this.pauseBtn.addEventListener('click', function () { self.paused ? self.play(true) : self.stop(true); });
      if (!this.auto) this.pauseBtn.hidden = true;
    }
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { self.go(self.i - 1, true); e.preventDefault(); }
      if (e.key === 'ArrowRight') { self.go(self.i + 1, true); e.preventDefault(); }
    });
    root.addEventListener('mouseenter', function () { self.hover = true; });
    root.addEventListener('mouseleave', function () { self.hover = false; });
    root.addEventListener('focusin', function () { self.hover = true; });
    root.addEventListener('focusout', function () { self.hover = false; });
    /* balayage tactile */
    var x0 = null, y0 = null;
    this.track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    this.track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.go(self.i + (dx < 0 ? 1 : -1), true);
      x0 = null;
    }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) self.clear(); else if (!self.paused) self.tick(); });
    this.update();
    if (this.auto) this.play(false);
  }
  Hero.prototype.go = function (k, user) {
    var n = this.slides.length;
    this.i = (k + n) % n;
    this.update(user);
    if (!this.paused) this.tick();
  };
  Hero.prototype.update = function (announce) {
    var self = this;
    this.track.style.transform = 'translateX(' + (-100 * this.i) + '%)';
    this.slides.forEach(function (s, k) {
      var on = k === self.i;
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
      s.inert = !on;
      if (on) {
        s.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      }
    });
    /* précharge la diapositive suivante */
    var nx = this.slides[(this.i + 1) % this.slides.length];
    if (nx) nx.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
    this.dots.forEach(function (d, k) { d.setAttribute('aria-current', k === self.i ? 'true' : 'false'); });
    if (announce && this.live) this.live.textContent = this.slides[this.i].getAttribute('aria-label') || '';
  };
  Hero.prototype.clear = function () { if (this.t) { clearTimeout(this.t); this.t = null; } };
  Hero.prototype.tick = function () {
    var self = this;
    this.clear();
    this.t = setTimeout(function () {
      if (!self.hover && !document.hidden) self.go(self.i + 1, false); else self.tick();
    }, this.delay);
  };
  Hero.prototype.play = function (user) {
    this.paused = false;
    this.root.classList.remove('is-paused');
    if (this.pauseBtn) {
      this.pauseBtn.setAttribute('aria-label', this.pauseBtn.dataset.pause);
      this.pauseBtn.innerHTML = '<svg viewBox="0 0 10 12" aria-hidden="true"><rect x="0" y="0" width="3" height="12" fill="currentColor"/><rect x="7" y="0" width="3" height="12" fill="currentColor"/></svg>';
    }
    this.tick();
  };
  Hero.prototype.stop = function () {
    this.paused = true;
    this.clear();
    this.root.classList.add('is-paused');
    if (this.pauseBtn) {
      this.pauseBtn.setAttribute('aria-label', this.pauseBtn.dataset.play);
      this.pauseBtn.innerHTML = '<svg viewBox="0 0 10 12" aria-hidden="true"><path d="M0 0l10 6-10 6z" fill="currentColor"/></svg>';
    }
  };

  /* ---------- Rangées défilantes ---------- */
  function Rail(root) {
    var track = root.querySelector('.udia-rail__track');
    if (!track) return;
    var prev = root.querySelector('[data-rail-prev]'), next = root.querySelector('[data-rail-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rail-dot]'));
    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      var w = first.getBoundingClientRect().width + gap;
      return Math.max(w, Math.floor(track.clientWidth / w) * w);
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max || max <= 0;
      if (dots.length) {
        var pages = dots.length, idx = max <= 0 ? 0 : Math.round(track.scrollLeft / max * (pages - 1));
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () {
        var max = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: dots.length > 1 ? max * k / (dots.length - 1) : 0, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function footerAcc() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.udia-acc[open]').forEach(function (d) { d.open = false; });
  }
  function init(scope) {
    footerAcc();
    (scope || document).querySelectorAll('[data-udia-hero]').forEach(function (el) { if (!el.__udia) { el.__udia = new Hero(el); } });
    (scope || document).querySelectorAll('[data-udia-rail]').forEach(function (el) { if (!el.__udia) { el.__udia = true; Rail(el); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
